'use client';
import { User } from '@relewise/client';
import { useRelewiseUser } from './useRelewiseUser';
import { useEffect } from 'react';
import create from 'zustand';

type InjectedData = {
  user: User;
};

type QueueItem = (injectedData: InjectedData) => void;

type QueueStore = {
  queue: QueueItem[];
  addToQueue: (item: QueueItem) => void;
  resolveQueue: (injectedData: InjectedData) => void;
};

const useQueueStore = create<QueueStore>((set) => ({
  queue: [],
  addToQueue: (item) => set((state) => ({ queue: [...state.queue, item] })),
  resolveQueue: (injectedData) => {
    set((state) => {
      state.queue.forEach((item) => {
        item(injectedData);
      });
      return { queue: [] };
    });
  },
}));

export const useRelewiseQueue = () => {
  const { queue, addToQueue, resolveQueue } = useQueueStore();
  const { user, hasConsent } = useRelewiseUser();

  const isTrackingReady = hasConsent && user;

  useEffect(() => {
    if (isTrackingReady && queue.length && user) {
      resolveQueue({ user });
    }
  }, [isTrackingReady, queue.length, user, resolveQueue]);

  return { addToQueue };
};